// src/app/connections/page.tsx
'use client';

import Link from "next/link";

export default function ConnectionsPage() {
  return (
    <main className="min-h-screen bg-white text-neutral-900">
      {/* Top Nav */}
      <header className="border-b">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
          <Link href="/" className="text-xl font-bold">
            <span className="text-indigo-600">Ad</span>Wisely
          </Link>
          <Link href="/" className="text-sm text-neutral-600 hover:text-neutral-900">
            Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <section className="mx-auto max-w-6xl px-4 py-10">
        <h1 className="text-3xl font-semibold">Connect your ad accounts</h1>
        <p className="mt-2 text-neutral-600">
          Link your platforms so we can pull performance and generate insights.
        </p>

        <div className="mt-8 grid gap-6 md:grid-cols-3">
          {/* Amazon → Active */}
          <ProviderCard
            name="Amazon Ads"
            desc="Sponsored Products, Brands & Display."
            badge="Upload"
            href="/upload/amazon"
            disabled={false}
          />

          {/* Google → Disabled */}
          <ProviderCard
            name="Google Ads"
            desc="Search, Performance Max, YouTube."
            badge="Coming Soon"
            href="/upload/google"
            disabled={true}
          />

          {/* Meta → Disabled */}
          <ProviderCard
            name="Meta Ads"
            desc="Facebook & Instagram advertising."
            badge="Coming Soon"
            href="/upload/meta"
            disabled={true}
          />
        </div>

        <div className="mt-10 rounded-xl border bg-neutral-50 p-4 text-sm text-neutral-700">
          Currently only Amazon Ads upload is enabled. Google and Meta will be added soon.
        </div>
      </section>
    </main>
  );
}

function ProviderCard({
  name,
  desc,
  href,
  badge,
  disabled = false,
}: {
  name: string;
  desc: string;
  href: string;
  badge?: string;
  disabled?: boolean;
}) {
  return (
    <div
      className={`rounded-xl border p-6 shadow-sm ${
        disabled ? "bg-neutral-100 opacity-60" : "bg-white"
      }`}
    >
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">{name}</h3>
        {badge ? (
          <span
            className={`rounded-full px-2 py-1 text-xs font-medium ${
              disabled
                ? "bg-neutral-200 text-neutral-600"
                : "bg-indigo-50 text-indigo-700"
            }`}
          >
            {badge}
          </span>
        ) : null}
      </div>
      <p className="mt-2 text-sm text-neutral-600">{desc}</p>
      {disabled ? (
        <button
          disabled
          className="mt-4 inline-flex items-center justify-center rounded-lg border px-4 py-2 text-sm font-medium text-neutral-400 cursor-not-allowed"
        >
          Connect
        </button>
      ) : (
        <Link
          href={href}
          className="mt-4 inline-flex items-center justify-center rounded-lg border px-4 py-2 text-sm font-medium hover:bg-neutral-50"
        >
          Connect
        </Link>
      )}
    </div>
  );
}
